module.exports = __webpack_public_path__ + "static/media/ecommerce1.61a8786d.png";